import { DeploymentVersions } from 'components/deployment-versions';

const DeploymentVersionsPage = () => {
  return <DeploymentVersions />;
};

export default DeploymentVersionsPage;
